import ErrorBoundary from "./ErrorBoundary";

export default ErrorBoundary;
export { ErrorBoundary };
